import { Thermometer, Home, Layers, Shield } from "lucide-react";

const systems = [
  {
    icon: Home,
    area: "Wohnraum",
    title: "Calciumsilikat & Holzfaser",
    description: "Feuchtigkeitsregulierende Calciumsilikatplatten oder ökologische Holzfaser – für ein gesundes, schimmelfreies Raumklima."
  },
  {
    icon: Layers,
    area: "Keller & Decken",
    title: "PUR/PIR-Hochleistung",
    description: "Hochleistungs-PUR/PIR-Platten bei geringer Aufbauhöhe – maximale Dämmwirkung auf minimalem Raum."
  },
  {
    icon: Shield,
    area: "Dachbereich",
    title: "Mineralwolle",
    description: "Klassische Mineralwolle für maximalen Brand- und Schallschutz – bewährt, sicher und langlebig."
  }
];

export const EnergieKlima = () => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-foreground text-background">
      <div className="container mx-auto">
        <div className="max-w-3xl mb-10 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-background/75 mb-4 block">
            Technik-Expertise
          </span>
          <h3 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Die richtige Dämmung für jedes Projekt in Herford
          </h3>
          <p className="text-lg text-background/85 leading-relaxed">
            Wir beherrschen die gesamte Klaviatur der modernen Dämmtechnik. Ob Mineralwolle (WLS 035) 
            für maximalen Brandschutz, preiswerte EPS-Platten oder die platzsparende Resol-Dämmung 
            (WLS 022) – wir finden die Lösung, die zu Ihrem Budget und Ihrem Haus passt.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-background/10 rounded-lg overflow-hidden">
          {systems.map((system, index) => {
            const Icon = system.icon;
            return (
              <div
                key={index}
                className="bg-foreground p-10 flex flex-col gap-6 hover:bg-secondary/10 transition-colors duration-500"
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-background/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-background" />
                  </div>
                  <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-background/75">
                    {system.area}
                  </span>
                </div>
                <h3 className="font-caslon text-2xl font-bold text-background">
                  {system.title}
                </h3>
                <p className="text-background/80 leading-relaxed">
                  {system.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-background/5 border border-background/10 rounded-lg px-6 py-3">
            <Thermometer className="w-4 h-4 text-background/85" />
            <span className="text-sm text-background/85">
              Individuelle Beratung – welches System passt zu Ihrem Gebäude?
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
